import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'ed-subject-builder-sidebar'
})
export default class EdSubjectBuilderSidebarComponent extends Vue {

  closeSidebar() {
    this.$emit('onCloseSidebar');
  }

}